import comp from "./TaskWeightV2";
export default comp;
